<template>
  <div class="form-group">
    <div class="checkbox">
      <label>
        <input type="checkbox"> {{ field.title }}
      </label>
    </div>
    <div v-on-click-outside="closeFieldSelector" class="field-pairing">
      <div class="subordinate">
        <input :value="richValue" type="text" class="form-control" :disabled="isOneToOnePairing" @input="handleInput">
      </div>
      <field-selector
        ref="fieldSelector"
        :source-fields="selectableSourceFields"
        :labels="labels"
        :show-clear-control="richValue && isOneToOnePairing"
        @selected="selectField"
        @cleared="clearSelection"
      >
      </field-selector>
    </div>
  </div>
</template>

<script>
import FieldPairing from './FieldPairing';

export default {
  extends: FieldPairing
};
</script>
